import request from '@/utils/request'


// 查询用户计划饮食信息列表
export function listDayDiet(query) {
  return request({
    url: '/user/dayDiet/list',
    method: 'get',
    params: query
  })
}

// 查询用户计划饮食信息分页
export function pageDayDiet(query) {
  return request({
    url: '/user/dayDiet/page',
    method: 'get',
    params: query
  })
}

// 查询用户计划饮食信息详细
export function getDayDiet(data) {
  return request({
    url: '/user/dayDiet/detail',
    method: 'get',
    params: data
  })
}

// 新增用户计划饮食信息
export function addDayDiet(data) {
  return request({
    url: '/user/dayDiet/add',
    method: 'post',
    data: data
  })
}

// 修改用户计划饮食信息
export function updateDayDiet(data) {
  return request({
    url: '/user/dayDiet/edit',
    method: 'post',
    data: data
  })
}

// 删除用户计划饮食信息
export function delDayDiet(data) {
  return request({
    url: '/user/dayDiet/delete',
    method: 'post',
    data: data
  })
}
